import React from 'react'

import MethodologySubTitle from 'components/CategoryInfoCard/components/FeaturesContent/components/MethodologySubTitle'
import Typography from 'components/Typography'

import classes from './KeyFeatures.module.scss'

const removeFeatureTitle = title => {
  const withIndex = title.indexOf('with')
  return withIndex === -1 ? title : title.substring(0, withIndex)
}

/** @type {import("./types").default} */
const KeyFeatures = ({ categoryName, keyFeatures }) => {
  const shortCategoryName = removeFeatureTitle(categoryName)

  const title = `Key features for ${shortCategoryName} software`

  // Find the summary item with key_features (typically the second item)
  const itemWithFeatures = keyFeatures.find(item => item.key_features && item.key_features.length > 0)

  // Find the introductory item with answer (typically the first item)
  const introItem = keyFeatures.find(item => item.answer)

  return (
    <>
      <Typography component="h2" className={classes.title}>
        {title}
      </Typography>

      <MethodologySubTitle />

      {introItem && introItem.answer && (
        <Typography component="p" className={classes.intro}>
          {introItem.answer}
        </Typography>
      )}

      {itemWithFeatures && (
        <ul className={classes.featuresList}>
          {itemWithFeatures.key_features.map(feature => (
            <li key={`key_feature_${feature.name}`}>
              <span className={classes.featureName}>{feature.name}</span>: {feature.definition}
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
export default KeyFeatures
